import Icon from '../components/Icon.vue'

Icon.register({"minus":{"width":1408,"height":1792,"paths":[{"d":"M1408 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"}]}})



// WEBPACK FOOTER //
// ./~/vue-awesome/icons/minus.js